import {
  LinearProgress as MuiLinearProgress,
  LinearProgressProps,
} from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { getDesignTokens } from '~c/components/base/core';

interface Props extends LinearProgressProps {
  className?: string;
  /**
   * Change the color of the completed portion of the progress
   * bar with the specified gradient color. Defaults to accent color.
   */
  gradientColor?: string;
}

const LinearProgressImpl = React.forwardRef<HTMLSpanElement, Props>(
  ({ className, gradientColor, ...props }, ref) => {
    return <MuiLinearProgress className={className} ref={ref} {...props} />;
  }
);

/**
 * Customized MUI LinearProgress component.
 *
 * It inherits all properties of a MUI LinearProgress
 */
export const LinearProgress = muiStyled(LinearProgressImpl)(({
  theme,
  value,
  gradientColor,
}) => {
  const tokens = getDesignTokens(theme.palette.mode, theme.accentPalette);
  const color = gradientColor ?? tokens.accent;
  return css`
    .MuiLinearProgress-bar {
      background: ${color};
    }
  `;
});

export default LinearProgress;
